<button
    type="button"
    class="btn btn-icon"
    data-cy="wdx-icon-button"
    [title]="buttonTitle | translateTokenisedString"
    [class.overflow-visible]="overflowVisible"
    [class.position-relative]="positionRelative"
    [class.btn-outline-primary]="wdxStyle === 'outline-primary'"
    [class.btn-primary]="wdxStyle === 'primary'"
    [class.btn-light]="wdxStyle === 'light'"
    [class.disabled]="disabled"
    [ngClass]="severity && 'btn-' + severity"
    [disabled]="disabled"
    [attr.aria-label]="buttonAriaLabel | translateTokenisedString"
    (click)="onClick($event)"
>
    <wdx-icon-container [size]="size">
        <ng-content></ng-content>
    </wdx-icon-container>
</button>
